import { CountryIsoCode } from './country';

export const CompanyIdentityQueryKeys = {
  all: ['CompanyIdentity'],
  company: (companyId: string) => ['CompanyIdentity', companyId],
};

export enum IdentityType {
  Company = 'COMPANY',
  Contractor = 'CONTRACTOR',
  Pa = 'PA',
  Person = 'PERSON',
}

export interface CompanyIdentity {
  address: string | null;
  addressCountry: CountryIsoCode | null;
  city: string | null;
  identityType: IdentityType | null;
  country: CountryIsoCode;
  id: string;
  companyName: string | null;
  postalCode: string | null;
  provinceCode: string | null;
  taxNumber: string;
  vatNumber: string | null;
  atecoSectorCode: string | null;
  rea: number | null;
  streetName: string | null;
  registeredOfficeCountry: CountryIsoCode | null;
}
